module.exports = __webpack_public_path__ + "static/media/logo.52b9dc1a.jpg";